import {
    Component,
    OnInit
} from '@angular/core';
import { MapService } from '../../../../../shared/layout/fap_main-map/service/map-service';

@Component({
    templateUrl: './insects-container.component.html'
})
export class InsectsContainerComponent implements OnInit {

    constructor(private mapService: MapService) {
    }

    public ngOnInit(): void {
        this.mapService.hideMap();
    }
}
